/* Hot Things BBQ comparison. No third-party libraries; fetch at most four products on demand. */
(function () {
  'use strict';
  if (/\/pages\/bbq-selector\/?$/.test(location.pathname) || window.htBBQCompareStarted) return;
  var config = document.querySelector('[data-htbc-config]');
  if (!config || typeof HTMLDialogElement === 'undefined') return;
  window.htBBQCompareStarted = true;
  var key = 'ht-bbq-compare-v1', selected = [], sequence = 0, previousFocus, scrollBefore;
  var root = config.dataset.root || '/', preview = new URLSearchParams(location.search).get('preview_theme_id');
  var app = document.createElement('div');
  app.id = 'htbc';
  app.innerHTML = '<div class="htbc-status" role="status" aria-live="polite"></div><aside class="htbc-tray" aria-label="Selected barbecues" hidden><div><strong data-htbc-count></strong><span class="htbc-hint">Choose up to four BBQs</span></div><div class="htbc-picks"></div><div class="htbc-actions"><button type="button" data-htbc-open>Compare</button><button type="button" data-htbc-clear class="htbc-secondary">Clear</button></div></aside><dialog aria-labelledby="htbc-title"><div class="htbc-dialog-head"><div><h2 id="htbc-title">Compare barbecues</h2><p>Scroll sideways to see every BBQ. Choose options on the product page.</p></div><button type="button" data-htbc-close class="htbc-secondary">Close</button></div><label class="htbc-difference"><input type="checkbox" data-htbc-difference> Show differences only</label><div class="htbc-results" aria-live="polite"></div><p class="htbc-note">Specifications are taken from the product listings. A dash means the detail has not been supplied, not that the feature is absent. Check the product page for full specifications and delivery conditions.</p></dialog>';
  document.body.appendChild(app);
  var tray = app.querySelector('.htbc-tray'), dialog = app.querySelector('dialog'), results = app.querySelector('.htbc-results');
  var status = app.querySelector('.htbc-status'), statusTimer;
  function message(text) {
    status.textContent = text;
    clearTimeout(statusTimer);
    statusTimer = setTimeout(function () { status.textContent = ''; }, 6000);
  }
  function read() {
    try {
      var saved = JSON.parse(localStorage.getItem(key) || '{}');
      if (!Array.isArray(saved.items) || !Number.isFinite(saved.at) || Date.now() - saved.at > 604800000) return [];
      var seen = new Set();
      return saved.items.filter(function (p) {
        if (!p || typeof p.handle !== 'string' || !/^[a-z0-9-]{1,255}$/.test(p.handle) || seen.has(p.handle)) return false;
        seen.add(p.handle); return true;
      }).slice(0, 4).map(function (p) { return {handle:p.handle, title:String(p.title || p.handle).slice(0, 300)}; });
    } catch (_) { return []; }
  }
  function save() { try { localStorage.setItem(key, JSON.stringify({at:Date.now(),items:selected})); } catch (_) {} }
  function el(tag, text, className) { var n = document.createElement(tag); if (text !== undefined) n.textContent = text; if (className) n.className = className; return n; }
  function button(text, action, handle) { var b=el('button',text); b.type='button'; b.setAttribute('data-htbc-'+action,handle || ''); return b; }
  function isSelected(handle) { return selected.some(function (p) { return p.handle === handle; }); }
  function update() {
    tray.hidden = selected.length === 0;
    app.querySelector('[data-htbc-count]').textContent = selected.length+' of 4 BBQs selected';
    var open = app.querySelector('[data-htbc-open]');
    open.textContent = 'Compare ('+selected.length+')'; open.disabled = selected.length < 2;
    var picks = app.querySelector('.htbc-picks'); picks.replaceChildren();
    selected.forEach(function (p) {
      var b = button(p.title+' ×','remove',p.handle); b.className='htbc-chip'; b.setAttribute('aria-label','Remove '+p.title+' from comparison'); picks.appendChild(b);
    });
    document.querySelectorAll('[data-htbc-add]').forEach(function (b) {
      var active=isSelected(b.dataset.htbcAdd); b.hidden=false; b.style.removeProperty('display');
      b.textContent=active?'Added to compare ✓':'Add to compare'; b.setAttribute('aria-pressed',String(active));
      b.setAttribute('aria-label',(active?'Remove ':'Add ')+(b.dataset.title || 'barbecue')+(active?' from comparison':' to comparison'));
    });
  }
  function activate(scope) {
    if (scope.querySelector('[data-htbc-add]') || (scope.matches && scope.matches('[data-htbc-add]'))) update();
  }
  function change(handle, title) {
    if (isSelected(handle)) selected = selected.filter(function(p){return p.handle !== handle;});
    else {
      if (selected.length >= 4) { message('You can compare four BBQs at a time. Remove one before adding another.'); return; }
      if (!/^[a-z0-9-]{1,255}$/.test(handle)) return;
      selected.push({handle:handle,title:String(title || handle).slice(0,300)});
    }
    save(); update();
    message(selected.length < 2 ? 'Choose another barbecue to compare.' : selected.length+' BBQs ready to compare.');
    if (dialog.open) { if (selected.length < 2) dialog.close(); else load(); }
  }
  function urlFor(handle, view) {
    var u=new URL(root+'products/'+encodeURIComponent(handle),location.origin);
    if (view) { u.searchParams.set('view','ht-compare-data'); u.searchParams.set('_htbc',String(Date.now())); }
    if (preview) u.searchParams.set('preview_theme_id',preview);
    return u.pathname+u.search;
  }
  async function get(p) {
    var ctl=new AbortController(), timer=setTimeout(function(){ctl.abort();},10000);
    try {
      var response=await fetch(urlFor(p.handle,true),{credentials:'same-origin',cache:'no-store',signal:ctl.signal});
      if (!response.ok) throw new Error('Product unavailable');
      var text=await response.text();
      // The alternate template is HTML containing one JSON block, so it also has a noindex directive.
      var doc=new DOMParser().parseFromString(text,'text/html'), block=doc.querySelector('[data-htbc-product]');
      if (!block) throw new Error('Comparison data missing');
      var data=JSON.parse(block.textContent);
      if (data.schema !== 1 || data.handle !== p.handle || data.eligible !== true || !Number.isFinite(data.priceMin) || !Number.isFinite(data.priceMax)) throw new Error('Product no longer eligible');
      return data;
    } finally { clearTimeout(timer); }
  }
  function value(v) { if(v === null || v === undefined || v === '') return '—'; if(typeof v === 'boolean') return v?'Yes':'No'; return Array.isArray(v)?v.join(', '):String(v); }
  function money(p) {
    var fmt=new Intl.NumberFormat(document.documentElement.lang || 'en-AU',{style:'currency',currency:p.currency || 'AUD'});
    return (p.priceMin !== p.priceMax?'From ':'')+fmt.format(p.priceMin/100);
  }
  var rows=[
    ['Brand',function(p){return p.vendor;}],
    ['Price',money],
    ['Fuel',function(p){return p.specs.bbq_fuel_type || p.specs.bbq_supported_fuels;}],
    ['Installation','bbq_installation_format'],['Main burners','gas_burners_main'],
    ['Cooking surface','bbq_cooking_surface_size'],['Primary cooking area (cm²)','bbq_primary_area_cm2'],['Total cooking area (cm²)','bbq_total_area_cm2'],
    ['Primary width (mm)','bbq_primary_width_mm'],['Primary depth (mm)','bbq_primary_depth_mm'],['Grill material','bbq_cooking_grill_material'],['Cooking zones / racks','bbq_total_cooking_zones'],
    ['Automatic temperature control','bbq_auto_temperature_control'],['Wi-Fi','bbq_wifi'],['Trolley included','bbq_trolley_included'],['Hood included','bbq_hood_included'],
    ['Temperature control','pel_temp_control'],['Temperature range','pel_temp_range'],['Pellet hopper','pel_hopper_capacity'],['Power source','pel_power_source'],['Meat probes','pel_meat_probe_ports'],['Smoke settings','pel_smoke_levels'],
    ['Dimensions (as listed)','bbq_dimensions'],['Weight','bbq_weight'],
    ['Perth delivery',function(){return config.dataset.delivery || null;}]
  ];
  function differences() {
    var only=app.querySelector('[data-htbc-difference]').checked;
    results.querySelectorAll('tbody tr').forEach(function(r){r.hidden=only && r.dataset.same==='true';});
  }
  function render(products, requested) {
    var scroll=el('div',undefined,'htbc-table-scroll'); scroll.tabIndex=0; scroll.setAttribute('role','region'); scroll.setAttribute('aria-label','Barbecue comparison table; scroll horizontally');
    var table=el('table'), head=el('thead'), tr=el('tr'); table.style.setProperty('--htbc-columns',String(products.length));
    var corner=el('th','Specification'); corner.scope='col'; tr.appendChild(corner);
    products.forEach(function(p,i){
      var th=el('th'); th.scope='col';
      if(p) {
        if(p.image) { try { var imageURL=new URL(p.image,location.origin); if(imageURL.protocol==='https:') {var im=el('img');im.src=imageURL.href;im.alt='';im.width=180;im.height=140;im.loading='lazy';th.appendChild(im);} } catch(_){} }
        var a=el('a',p.title); a.href=urlFor(p.handle,false); th.appendChild(a);
        var link=el('a','View BBQ & options','htbc-product-link');link.href=urlFor(p.handle,false);th.appendChild(link);
      } else { th.appendChild(el('strong',requested[i].title));th.appendChild(el('p','Could not load current details. Please retry or view the product.','htbc-error'));var fallback=el('a','View product');fallback.href=urlFor(requested[i].handle,false);th.appendChild(fallback); }
      var remove=button('Remove','remove',requested[i].handle);remove.className='htbc-secondary';remove.setAttribute('aria-label','Remove '+requested[i].title+' from comparison');th.appendChild(remove);tr.appendChild(th);
    });
    head.appendChild(tr);table.appendChild(head);var body=el('tbody');
    rows.forEach(function(row){
      var vals=products.map(function(p){return p?value(typeof row[1]==='function'?row[1](p):p.specs[row[1]]):'Unavailable';});
      if(vals.every(function(v){return v==='—' || v==='Unavailable';})) return;
      var r=el('tr');r.dataset.same=String(vals.every(function(v){return v===vals[0];}));
      var label=el('th',row[0]);label.scope='row';r.appendChild(label);
      vals.forEach(function(v){r.appendChild(el('td',v));});body.appendChild(r);
    });
    table.appendChild(body);scroll.appendChild(table);results.replaceChildren(scroll);
    if(products.some(function(p){return !p;})) results.appendChild(button('Retry loading current details','retry'));
    differences();
  }
  async function load() {
    var version=++sequence, requested=selected.slice();
    results.replaceChildren(el('p','Loading current prices and specifications…'));
    var data=await Promise.all(requested.map(function(p){return get(p).catch(function(){return null;});}));
    if (version !== sequence || !dialog.open) return;
    data.forEach(function(p){if(p && (!p.specs || typeof p.specs !== 'object')) p.specs={};});
    render(data,requested);
  }
  document.addEventListener('click',function(e){
    var add=e.target.closest('[data-htbc-add]');
    if(add){e.preventDefault();e.stopImmediatePropagation();change(add.dataset.htbcAdd,add.dataset.title);return;}
    if(!app.contains(e.target))return;
    var remove=e.target.closest('[data-htbc-remove]');if(remove){change(remove.dataset.htbcRemove);return;}
    if(e.target.closest('[data-htbc-clear]')){selected=[];save();update();if(dialog.open)dialog.close();return;}
    if(e.target.closest('[data-htbc-open]') && selected.length>=2){previousFocus=e.target;scrollBefore=document.body.style.overflow;dialog.showModal();document.body.style.overflow='hidden';load();return;}
    if(e.target.closest('[data-htbc-close]')){dialog.close();return;}
    if(e.target.closest('[data-htbc-retry]'))load();
  },true);
  dialog.addEventListener('close',function(){sequence++;document.body.style.overflow=scrollBefore || '';if(previousFocus && previousFocus.isConnected)previousFocus.focus();});
  app.querySelector('[data-htbc-difference]').addEventListener('change',differences);
  window.addEventListener('storage',function(e){if(e.key===key){selected=read();update();if(dialog.open){if(selected.length<2)dialog.close();else load();}}});
  var template=document.querySelector('template[data-htbc-product-button]');
  if(template){
    var target=document.querySelector('#content form[action*="/cart/add"]:not(.form-card)') || document.querySelector('#content h1');
    if(target){var holder=el('div',undefined,'htbc-product-button');holder.appendChild(template.content.cloneNode(true));target.insertAdjacentElement('afterend',holder);}
  }
  selected=read();update();
  // Only inspect newly added product cards, not every change to the entire page.
  var content=document.querySelector('#content');
  if(content)new MutationObserver(function(changes){changes.forEach(function(change){change.addedNodes.forEach(function(n){if(n.nodeType===1 && !n.closest('#htbc'))activate(n);});});}).observe(content,{childList:true,subtree:true});
})();
